import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\DuplicateDocumentV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/DuplicateDocumentV3Controller.php
* @route '/api/editor/{type}/{document}/duplicate-v3'
*/
const DuplicateDocumentV3Controller = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateDocumentV3Controller.url(args, options),
    method: 'post',
})

DuplicateDocumentV3Controller.definition = {
    methods: ["post"],
    url: '/api/editor/{type}/{document}/duplicate-v3',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\Editor\DuplicateDocumentV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/DuplicateDocumentV3Controller.php
* @route '/api/editor/{type}/{document}/duplicate-v3'
*/
DuplicateDocumentV3Controller.url = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
    }

    return DuplicateDocumentV3Controller.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\DuplicateDocumentV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/DuplicateDocumentV3Controller.php
* @route '/api/editor/{type}/{document}/duplicate-v3'
*/
DuplicateDocumentV3Controller.post = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateDocumentV3Controller.url(args, options),
    method: 'post',
})

export default DuplicateDocumentV3Controller